"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { useWavesOverview } from "./useWavesOverview";
import { WAVE_FOLLOWING_WAVES_PARAMS } from "@/components/react-query-wrapper/utils/query-utils";
const useDmWavesList = () => {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      type: WAVE_FOLLOWING_WAVES_PARAMS.initialWavesOverviewType,
      limit: WAVE_FOLLOWING_WAVES_PARAMS.limit,
      directMessage: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    waves: mainWaves,
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    status,
    refetch
  } = useWavesOverview(t0);
  let t1;
  if ($[1] !== mainWaves) {
    t1 = [...mainWaves].sort(_temp);
    $[1] = mainWaves;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sorted = t1;
  const addPinnedWave = _temp2;
  const removePinnedWave = _temp3;
  let t2;
  if ($[3] !== fetchNextPage) {
    t2 = () => fetchNextPage();
    $[3] = fetchNextPage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fetchNextPageStable = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== fetchNextPageStable || $[8] !== hasNextPage || $[9] !== isFetching || $[10] !== isFetchingNextPage || $[11] !== mainWaves || $[12] !== refetch || $[13] !== sorted || $[14] !== status) {
    t5 = {
      waves: sorted,
      isFetching,
      isFetchingNextPage,
      hasNextPage,
      fetchNextPage: fetchNextPageStable,
      status,
      pinnedWaves: t3,
      isPinnedWavesLoading: false,
      hasPinnedWavesError: false,
      addPinnedWave,
      removePinnedWave,
      mainWaves,
      missingPinnedIds: t4,
      mainWavesRefetch: refetch,
      refetchAllWaves: refetch
    };
    $[7] = fetchNextPageStable;
    $[8] = hasNextPage;
    $[9] = isFetching;
    $[10] = isFetchingNextPage;
    $[11] = mainWaves;
    $[12] = refetch;
    $[13] = sorted;
    $[14] = status;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default useDmWavesList;
function _temp(a, b) {
  return b.metrics.latest_drop_timestamp - a.metrics.latest_drop_timestamp;
}
function _temp2() {}
function _temp3() {}